import clsx from 'clsx'
import React from 'react'

import { Background } from '@Components/Background'
import { Chip } from '@Components/Chips/Chip/Chip'
import { Link } from '@Components/Link'
import { RTEContent } from '@Components/RTEContent'
import { BlockCommon, ReferenceContentFragment, RteField } from '@Generated/graphql'
import { convertRTEToHTML, getPageReferences } from '@Globals/CMS/FieldHelpers'

import styles from './styles.module.scss'

type CommonContentProps = {
  className?: string
  common: BlockCommon
}

export const CommonContent: React.FC<CommonContentProps> = ({ className, common }) => {
  const { chips, label, text, title, titleElement } = common
  const TitleElement = (titleElement || 'p') as keyof React.JSX.IntrinsicElements
  return (
    <div className={clsx(styles.wrapper, className)}>
      {label && (
        <Chip
          backgroundColor={label.appearance?.backgroundColor || 'rgba(21, 26, 28, 0.3)'}
          className={styles.label}
          color={label.text?.value?.toLowerCase()}
          size="large"
          textColor={label.appearance?.textColor || 'var(--white)'}
        >
          {label.text?.value}
        </Chip>
      )}
      {title && (
        <TitleElement className={styles.title}>
          {title}
        </TitleElement>
      )}
      {text && (
        <div className={styles.text}>
          <RTEContent html={convertRTEToHTML(text as RteField | null | undefined)} />
        </div>
      )}
      {chips && chips.length > 0 && (
        <div className={styles.chips}>
          {chips.map(chip => (
            <Link
              key={`chip__${chip.link?.id}`}
              className={styles.chip}
              href={chip.link?.url || ''}
              style={{
                backgroundColor: chip.appearance?.backgroundColor || '',
                borderColor: chip.appearance?.backgroundColor ? 'transparent' : '',
                color: chip.appearance?.textColor || '',
              }}
              target={chip.link!.newTab ? '_blank' : undefined}
            >
              <Background asset={chip.appearance?.asset as ReferenceContentFragment} />
              {getPageReferences(chip.link?.references || [])?.[0].title || ''}
            </Link>
          ))}
        </div>
      )}
    </div>
  )
}
